// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3JROV","noInteraction":"EventWrapper_noInteraction__2Ngf4","pointerPassthrough":"EventWrapper_pointerPassthrough__1Z62x"};